module.exports = __webpack_public_path__ + "static/img/cont50 (1).74dac30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont50 (1).jpg
// module id = Qss6
// module chunks = 0